var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFaceEyesclosedFilled = function SvgFaceEyesclosedFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.875 12c0-5.445-4.43-9.875-9.875-9.875S2.125 6.555 2.125 12s4.43 9.875 9.875 9.875 9.875-4.43 9.875-9.875Zm-4.851-2.234c0-.829-.746-1.503-1.663-1.503-.827 0-1.518.535-1.643 1.273a.482.482 0 1 0 .95.162c.045-.264.35-.47.693-.47.379 0 .699.246.699.538a.482.482 0 1 0 .964 0Zm-9.084 0c0-.292.32-.539.699-.539.343 0 .648.207.693.47a.483.483 0 0 0 .95-.161c-.125-.738-.816-1.273-1.643-1.273-.917 0-1.663.675-1.663 1.503a.482.482 0 1 0 .964 0Zm3.959 5.97c-.081 0-.163-.001-.245-.005-1.2-.059-2.264-.553-2.92-1.358a.482.482 0 0 1 .748-.61c.482.594 1.292.96 2.219 1.005 1.1.054 2.173-.335 2.87-1.039a.482.482 0 0 1 .685.679c-.833.841-2.074 1.329-3.357 1.329Z",
    fill: "#000"
  })));
};
export default SvgFaceEyesclosedFilled;